<template>
  <div id="organization-position-content" class="organization-position-content">
    <div class="organization-position-tool-top-flex">
      <div>
        <a-button type="primary" style="margin-right: 8px" @click="() => handleAdd()">
          <i type="plus"></i>{{ $t('page_role_management_add_member') }}
        </a-button>
        <a-button
          type="danger"
          :disabled="!this.selectedRowKeys.length"
          style="margin-right: 8px"
          @click="() => handleDelete()"
        >
          {{ $t('page_role_management_remove_member') }}
        </a-button>
      </div>
      <div>
        <a-input-search
          :value="filter.keywords"
          :placeholder="$t('placeholder')"
          :enterButton="$t('search')"
          style="width: 220px"
          @change="changeKeys"
          @search="search"
        />
      </div>
    </div>
    <div class="organization-position-tablelist">
      <ml-table
        :columns="selectTab === '1' ? organizationColumns : postColumns"
        :data-source="tableData"
        rowKey="key"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        :scroll="{ y: scrollY }"
      >
      </ml-table>
    </div>
    <add-person
      :visible="addVisible"
      :postId="filter.postId"
      :selectTab="selectTab"
      :organizationId="organizationId"
      @cancel="cancelAdd"
      @ok="(value) => savePerson(value)"
    ></add-person>
  </div>
</template>

<script>
import AddPerson from './AddPerson.vue'
import {
  UserPostServiceProxy,
  UserOrganizationServiceProxy
} from '@/service-proxies/app-v2/user.service-proxies'

const upsp = new UserPostServiceProxy()
const uosp = new UserOrganizationServiceProxy()

export default {
  props: {
    filter: {
      type: Object,
      default: () => ({})
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    selectTab: {
      type: String,
      default: ''
    },
    organizationId: {
      type: String,
      default: ''
    }
  },
  components: {
    AddPerson
  },
  data() {
    return {
      addVisible: false,
      selectedRowKeys: [],
      scrollY: 0
    }
  },
  computed: {
    tableData() {
      let val = []
      if (this.dataSource && this.dataSource.length) {
        val = this.dataSource.map((res) => {
          const item = { ...res }
          item.key = res.id || res.userId
          return item
        })
      }
      return val
    },
    organizationColumns() {
      return [
        {
          title: this.$t('page_transport_directory_account_number'),
          dataIndex: 'account',
          key: 'account'
        },
        {
          title: this.$t('page_user_management_user_nickname'),
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: this.$t('page_user_management_user_name'),
          dataIndex: 'realName',
          key: 'realName'
        },
        {
          title: this.$t('page_position'),
          key: 'postName',
          dataIndex: 'postName'
        },
        {
          title: this.$t('page_user_management_subordinate_departments'),
          key: 'organizationName',
          dataIndex: 'organizationName'
        }
      ]
    },
    postColumns() {
      return [
        {
          title: this.$t('page_transport_directory_account_number'),
          dataIndex: 'account',
          key: 'account'
        },
        {
          title: this.$t('page_user_management_user_nickname'),
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: this.$t('page_user_management_user_name'),
          dataIndex: 'realName',
          key: 'realName'
        },
        {
          title: this.$t('page_user_management_subordinate_departments'),
          key: 'organizationName',
          dataIndex: 'organizationName'
        }
      ]
    }
  },
  mounted() {
    this.checkScroll()
  },
  watch: {
    dataSource: {
      handler() {
        this.checkScroll()
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    checkScroll() {
      this.selectedRowKeys = []
      this.scrollY = 0
      const dev = document.documentElement
      if (
        this.dataSource &&
        dev.clientHeight &&
        this.dataSource.length * 31 > dev.clientHeight - 200
      ) {
        this.scrollY = dev.clientHeight - 210
      }
    },
    handleAdd() {
      this.addVisible = true
    },
    cancelAdd() {
      this.addVisible = false
    },
    savePerson(value) {
      if (this.selectTab == '2') {
        this.savePosition(value)
      } else {
        this.saveOrganization(value)
      }
    },
    changeKeys(value) {
      this.$emit('changeKeys', value.target.value)
    },
    search() {
      this.$emit('search')
    },
    async saveOrganization(value) {
      if (value && value.length) {
        const dto = {
          organizationId: this.organizationId,
          userIdList: value
        }
        await uosp.saveOrganizationUsers(dto)
        this.$emit('reload')
        this.$message.success(this.$t('page_material_ware_add_success'))
        this.addVisible = false
      } else {
        this.addVisible = false
      }
    },
    async savePosition(value) {
      if (value && value.length) {
        const dto = {
          postId: this.filter.postId,
          userIdList: value
        }
        await upsp.savePostUsers(dto)
        this.$emit('reload')
        this.$message.success(this.$t('page_material_ware_add_success'))
        this.addVisible = false
      } else {
        this.addVisible = false
      }
    },
    async handleDelete() {
      this.$confirm({
        icon: () => <a-icon style="color: #ff0000" type="exclamation-circle" />,
        title: this.$t('page_station_comprehensive_remove_people'),
        content: this.$t('page_station_comprehensive_remove_people_confirm'),
        onOk: () => {
          if (this.selectTab == '2') {
            this.deletePerson()
          } else {
            this.deleteOrganization()
          }
        },
        class: 'test'
      })
    },
    async deletePerson() {
      const dto = {
        postId: this.filter.postId,
        userIdList: this.selectedRowKeys
      }
      await upsp.deletePostUsers(dto)
      this.$emit('reload')
      this.$message.success(this.$t('page_console_notification_rule_delete_success'))
    },
    async deleteOrganization() {
      const dto = {
        organizationId: this.organizationId,
        userIdList: this.selectedRowKeys
      }
      await uosp.deleteOrganizationUsers(dto)
      this.$emit('reload')
      this.$message.success(this.$t('page_console_notification_rule_delete_success'))
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    }
  }
}
</script>

<style lang="less" scoped>
.organization-position-content {
  background: #ffffff;
  margin-left: 10px;
  flex: 1;
  height: 100%;
  border: 1px solid #d7d7d7;
  padding: 8px;
  .organization-position-tool-top-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 8px;
  }
}
</style>
